import React, { Component } from 'react'
import './search-box.scss';

export default class SearchBox extends Component {
  render() {
    return (
      <div className="search-box">
        <i className='icon-search'/>
        {this.props.text}：
        <span>
          <input type="text" ref="searchValue" onChange={() => this.props.onChange(this.refs.searchValue.value)} />
          <button onClick={() => this.props.action(this.refs.searchValue.value)}>查询</button>
        </span>
      </div>
    )
  }
}
